let _conference: any|undefined = undefined

export const setConference = (conference: any) => {
  _conference = conference;
};
export const getConference = (): any => {
  return _conference!
}
